export const defaultStages = [
  { id: 'stage-new', name: 'New' },
  { id: 'stage-contacted', name: 'Contacted' },
  { id: 'stage-qualified', name: 'Qualified' },
  { id: 'stage-proposal', name: 'Proposal' },
  { id: 'stage-closed-won', name: 'Closed Won' },
] as const;

export function resolveStageId(input: string | null | undefined): string {
  if (!input) {
    return defaultStages[0].id;
  }
  const normalized = input.toLowerCase().trim();
  const exactMatch = defaultStages.find((stage) => stage.id.toLowerCase() === normalized);
  if (exactMatch) {
    return exactMatch.id;
  }
  const nameMatch = defaultStages.find((stage) => stage.name.toLowerCase() === normalized);
  if (nameMatch) {
    return nameMatch.id;
  }
  return defaultStages[0].id;
}
